import React from 'react';
import { ShowsContext } from 'providers/Shows';

const useShows = () => React.useContext(ShowsContext);
export default useShows;
